import React, {useCallback} from 'react';
import RecordedMix from './RecordedMix.js';
import Toolbar from './Toolbar.js';
import ClockComponent from 'components/toolbar/ClockComponent.js';
import RollButtons from './RollButtons.js';
import {connect} from 'react-redux';
import WorkMixer from './WorkMixer.js';
import Sampler from './Sampler.js';
import WorkMix from '../work/WorkMix.js';

const Mixer = ({
    worksLoaded,
    sequencerEngine,
    unloadWork,
    samplersLoaded,
    deleteSample,
    mixLoaded,
    mixHasEdits,
    children,
    lists,
}) => {

    const clearMix = useCallback(() => {
        sequencerEngine.unloadAll();
    }, [sequencerEngine]);

    if (sequencerEngine === undefined) {
        return (<div></div>);
    }

    let loadedMixComponent = '';
    if (mixLoaded) {
        loadedMixComponent = (
            <WorkMix
              mixHasEdits={true}
              sequencerEngine={sequencerEngine}
              mixMode={true}
              onClick={clearMix}
              work={mixLoaded}/>
        );
    }

    return (
        <div className="mixer no-select">
          <div className="mixer-and-works">
            <Toolbar sequencerEngine={sequencerEngine}/>
            <div className="works-container">
              {worksLoaded.map(
                  (work, i) =>
                      <WorkMixer
                      workNumber={i}
                        key={work.newSequence}
                        unloadWork={() => unloadWork(work)}
                        sequencerEngine={sequencerEngine} work={work}/>)}
              <Sampler
                sequencerEngine={sequencerEngine}
                deleteSample={deleteSample}
                samplersLoaded={samplersLoaded}/>
              {mixLoaded ? loadedMixComponent : ''}
              {mixHasEdits ? 
               <RecordedMix
                 originalMix={mixLoaded}
                 sequencerEngine={sequencerEngine}/> : ''}
            </div>
            {lists}
          </div>
          {children}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        headSequencerEngine: props.sequencerEngine && props.sequencerEngine.headSequencerEngine,
        mixLoaded: state.explore.mixLoaded,
        mixHasEdits: state.explore.mixHasEdits
    };
};

export default connect(mapStateToProps, null)(Mixer);
